export default __webpack_public_path__ + "huddle-plus-logo.5656121e.svg";